import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'
import pageOverlayOpeningCallback from 'foundation/js/pageOverlayOpeningCallback'
import pageOverlayClosingCallback from 'foundation/js/pageOverlayClosingCallback'

import componentsToInititalize from './OverlayComponents.init'

const el = '.kb-component--overlay-link-interceptor'
const DOM = document.querySelector(el)
const overlayLinksEl = '[content-type=overlaylinks]'

const isVisible = function (element) {
    if (
        window.getComputedStyle(element).getPropertyValue('visibility') ===
        'hidden'
    ) {
        return false
    }
    if (
        window.getComputedStyle(element).getPropertyValue('display') === 'none'
    ) {
        return false
    }

    return true
}

const getLastAnchor = function (overlay) {
    let last = undefined
    Array.from(overlay.querySelectorAll('a')).map((elem) => {
        let lastNotFound = true
        if (isVisible(elem) && lastNotFound) {
            elem.dataset.order = 'last'
            lastNotFound = false
            last = elem
        }
    })
    return last
}

const getFirstAnchor = function (overlay) {
    let first = undefined
    Array.from(overlay.querySelectorAll('a'))
        .toReversed()
        .map((elem) => {
            let firstNotFound = true
            if (isVisible(elem) && firstNotFound) {
                elem.dataset.order = 'first'
                firstNotFound = false
                first = elem
            }
        })
    return first
}

export default function (Store) {
    if (!DOM || DOM.hasAttribute('data-v-app')) return

    const openArticleOverlay = function (overlay, content) {
        overlay.querySelector('.kb-article-overlay--target').innerHTML = content
        overlay.querySelector('.kb-article-overlay--target').scrollTop = 0 // scroll should be reset inside overlay

        const last = getLastAnchor(overlay)
        const first = getFirstAnchor(overlay)

        last.addEventListener('keydown', (e) => {
            if (!e.shiftKey) {
                e.preventDefault()
                first.focus()
            }
        })

        first.addEventListener('keydown', (e) => {
            if (e.shiftKey) {
                e.preventDefault()
                last.focus()
            }
        })

        componentsToInititalize(Store)
        overlay
            .querySelector('.kb-page-overlay__container')
            .classList.add('open')
        Store.commit('main/set_article_overlay_open', true)
        onTransitionendCallback({
            opening() {
                pageOverlayOpeningCallback()
                overlay.querySelector('.kb-page-overlay__close').focus()
            },
            statePropName: 'article_overlay_open',
            parent: overlay
        })
    }

    const closeArticleOverlay = function (overlay) {
        overlay
            .querySelector('.kb-page-overlay__container')
            .classList.remove('open')
        overlay
            .querySelector('.kb-page-overlay__container')
            .classList.add('closed')
        Store.commit('main/set_article_overlay_open', false)
        onTransitionendCallback({
            closing() {
                overlay
                    .querySelector('.kb-page-overlay__container')
                    .classList.remove('closed')
                overlay
                    .querySelector('.kb-page-overlay__container')
                    .classList.add('ready')
                pageOverlayClosingCallback()
            },
            statePropName: 'article_overlay_open',
            parent: overlay
        })
    }

    const overlay = document.createElement('div')
    overlay.classList.add('kb-page-overlay')
    overlay.innerHTML =
        '<div class="kb-page-overlay__container"> <div class="kb-page-overlay__cover"></div> <div class="kb-page-overlay__content"><button class="kb-page-overlay__close" aria-label="Luk artikel"><div class="kb-ui-icon kb-ui-icon--ui-close"></div></button><div class="kb-article-overlay kb-article-overlay--target"></div></div> </div>'
    overlay
        .querySelector('.kb-page-overlay__close')
        .addEventListener('click', closeArticleOverlay.bind(this, overlay))
    overlay
        .querySelector('.kb-page-overlay__cover')
        .addEventListener('click', closeArticleOverlay.bind(this, overlay))
    overlay
        .querySelector('.kb-page-overlay__container')
        .addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeArticleOverlay(overlay)
        })

    const clickHandler = function (e) {
        e.preventDefault()
        var href = process.env.ARTICLEOVERLAY_DATA
            ? process.env.ARTICLEOVERLAY_DATA
            : e.target.getAttribute('href')

        if (!href) {
            href = e.target.closest('a').getAttribute('href')
        }

        Store.dispatch('main/getArticleOverlayContent', href).then(
            (content) => {
                openArticleOverlay(overlay, content)
            }
        )
    }

    if (DOM && document.querySelector(overlayLinksEl)) {
        const DOM_LINKS = document.querySelector(overlayLinksEl)
        const overlayLinks = JSON.parse(DOM_LINKS.textContent)
        if (!document.body.contains(overlay)) document.body.appendChild(overlay)

        overlayLinks.forEach((element) => {
            // Add data-overlay-link attribute to all links to given element, that are inside rich text blocks
            const richTextElements = document.querySelectorAll('.kb-rich-text')

            richTextElements.forEach((richTextElement) => {
                richTextElement
                    .querySelectorAll(`a[href='${element}']`)
                    .forEach((link) => {
                        if (!link.hasAttribute('target')) {
                            link.setAttribute('data-overlay-link', true);
                        }
                    });
            });            
        })

        document
            .querySelectorAll('[data-overlay-link]')
            .forEach((link) => link.addEventListener('click', clickHandler))
    }
}
